var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 0.583344C3.45228 0.583344 0.583344 3.45228 0.583344 7C0.583344 10.5478 3.45228 13.4167 7 13.4167C10.5478 13.4167 13.4167 10.5478 13.4167 7C13.4167 3.45228 10.5478 0.583344 7 0.583344ZM7 5.85417C7.30242 5.85417 7.54167 6.09342 7.54167 6.39584V9.91667C7.54167 10.2191 7.30242 10.4583 7 10.4583C6.69759 10.4583 6.45834 10.2191 6.45834 9.91667V6.39584C6.45834 6.09342 6.69759 5.85417 7 5.85417ZM7.81251 4.39584C7.81251 4.84372 7.44789 5.20834 7 5.20834C6.55212 5.20834 6.18751 4.84372 6.18751 4.39584C6.18751 3.94796 6.55212 3.58334 7 3.58334C7.44789 3.58334 7.81251 3.94796 7.81251 4.39584Z",
    fill: "#0A86E3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.8f2d2e66efb806e271b4a96f3affa1b8.svg";
export { ForwardRef as ReactComponent };